import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'marketwatchformatter'
})
export class MarketwatchformatterPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) { }
  
  transform(value: any, ...args: any[]): any {

    if (value == null || value == undefined || value == 0 || value == -1) {
      return "";
    }

    if( typeof(value) === 'string' ) {
      return value;
    }

    return this.decimalPipe.transform(value, ...args);
  }

}
